import { render, staticRenderFns } from "./GenericChart.vue?vue&type=template&id=bcf51790&scoped=true&"
import script from "./GenericChart.vue?vue&type=script&lang=js&"
export * from "./GenericChart.vue?vue&type=script&lang=js&"
import style0 from "./GenericChart.vue?vue&type=style&index=0&id=bcf51790&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf51790",
  null
  
)

export default component.exports